/**
 * Created by Anastasiya on 17.05.2024
 */

const TradeWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        this.trade = new UnitTrade();

        this._super({
            title: Messages.get("TradeWindow.Title"),
            name: "tradewindow",
            content: this.getContent(),
            help: function () {
                cleverapps.focusManager.display({
                    focus: "TradeGuideWindow",
                    stack: true,
                    action: (f) => {
                        new GuideWindow({
                            name: "TradeGuideWindow",
                            bundle: bundles.tradeguidewindow
                        });

                        cleverapps.focusManager.onceNoWindowsListener = f;
                    }
                });
            },
            styles: cleverapps.styles.TradeWindow.window
        });

        this.trade.on("pickChange", this.updateButton.bind(this), this);

        cleverapps.metrics.logEvent(cleverapps.EVENTS.TRADE_WINDOW_OPEN);
    },

    onShow: function () {
        this._super();
        cleverapps.tutorial.trigger("trade_window_opened");
    },

    getContent: function () {
        const styles = cleverapps.styles.TradeWindow;
        this.sourcePicker = new TradePicker(UnitTrade.SOURCE, this.trade);
        this.targetPicker = new TradePicker(UnitTrade.TARGET, this.trade);

        const layout = new cleverapps.Layout([this.sourcePicker, this.targetPicker], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });

        const arrow = new cc.Sprite(bundles.tradewindow.frames.arrow);
        arrow.setAlignment(styles.arrow);
        layout.addChild(arrow);

        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.addChild(layout);
        cleverapps.UI.wrap(content);

        this.button = this.createButton();
        this.button.setAlignment(styles.button);
        content.addChild(this.button);
        this.updateButton();

        return content;
    },

    getSourcePicker: function () {
        return this.sourcePicker;
    },

    getTargetPicker: function () {
        return this.targetPicker;
    },

    getExchangeButton: function () {
        return this.button;
    },

    createButton: function () {
        const styles = cleverapps.styles.TradeWindow.button;
        return new cleverapps.UI.Button({
            text: Messages.get("TradeWindow.ButtonTitle"),
            width: styles.width,
            height: styles.height,
            onClicked: function () {
                if (cleverapps.forces.getRunningForce()) {
                    cleverapps.forces.closeRunningForce();
                }
                this.exchange = true;
                this.close();
            }.bind(this)
        });
    },

    updateButton: function () {
        if (this.trade.getSelected(UnitTrade.SOURCE) && this.trade.getSelected(UnitTrade.TARGET)) {
            this.button.enable();
        } else {
            this.button.disable();
        }
    },

    beforeCloseAnimation: function (callback) {
        if (!this.exchange) {
            callback();
            return;
        }

        const windowComponent = ComponentMap.get(this, WindowComponent);
        windowComponent.hideWindow();
        this.trade.exchange(callback);
    },

    listBundles: function () {
        return ["tradewindow"];
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    TRADE_WINDOW_SELECT_HINT: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.TradeWindow = {
    margin: 25,

    window: {
        padding: {
            x: 35,
            top: 35,
            bottom: 40
        }
    },

    column: {
        width: 700,
        height: 700
    },

    arrow: {
        x: { align: "center", dx: 22 },
        y: { align: "top", dy: -60 }
    },

    button: {
        width: 350,
        height: 100,
        x: { align: "center" },
        y: { align: "bottom", dy: -105 }
    }
};